export default {
	label: "Search",
	placeholder: "Search products, brands or advice",
	productListLabel: "Our most popular results matching",
	popularSearchLabel: "Popular searches",
	close: "Close"
};
